import { useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Image from "next/legacy/image";

interface StepTwoProps {
  error?: string;
}

const StepTwo: React.FC<StepTwoProps> = ({ error }) => {
  const { control, setValue } = useFormContext();
  const value = useRef('');
  const jobZone1Ref = useRef<HTMLDivElement>(null);
  const jobZone2Ref = useRef<HTMLDivElement>(null);
  const jobZone3Ref = useRef<HTMLDivElement>(null);
  const jobZone4Ref = useRef<HTMLDivElement>(null);
  const jobZone5Ref = useRef<HTMLDivElement>(null);

  const handleChange = (jobZone: string) => {
    const zones = [
      'Days to months',
      'Up to 1 year',
      'Up to 1-2 years',
      'Up to 4 years',
      'More than 4 years',
    ];
    const formVal = zones[Number(jobZone) - 1];

    const isChecked = value.current == jobZone;
    if (!isChecked) {
      setValue('type', formVal);
      value.current = jobZone;
    } else {
      setValue('type', '');
      value.current = '';
      return;
    }

    setStyleRefs();
  };

  const setStyleRefs = () => {
    const keys = ['1', '2', '3', '4', '5'];
    const zones = [
      jobZone1Ref,
      jobZone2Ref,
      jobZone3Ref,
      jobZone4Ref,
      jobZone5Ref,
    ];

    // clean the zones
    zones.forEach((zone) => {
      zone.current?.classList.remove('top', 'middle', 'bottom');
    });
    if (value) {
      jobZone1Ref.current?.classList.add('top');
    } else {
      jobZone1Ref.current?.classList.remove('top');
    }
    for (const [index, key] of keys.entries()) {
      if (key < value.current) {
        zones[index].current?.classList.add('middle');
      }
      if (key == value.current) {
        zones[index].current?.classList.add('bottom');
      }
    }
  };
  return (
    <>
      <Image
        src="/images/career-quiz-step-2.svg"
        blurDataURL="/images/career-quiz-step-2.svg"
        layout="responsive"
        loading="eager"
        placeholder="blur"
        width={2500}
        height={2000}
        alt="Icon of a person sitting at a computer"
        className="self-center block w-32 mx-auto my-2 md:my-0 md:w-44"
      />
      <div className="p-2 md:p-8">
        <h1 className="text-2xl font-semibold text-center text-careerPageHeading md:text-left md:text-3xl">
          Which <span className="text-careerPageHighlight">length</span> of job
          training are you open to?
        </h1>
        {error && <p className="mt-4 italic font-semibold text-red">{error}</p>}

        <div className="my-6 job-zones">
          <div className="flex items-center my-4">
            <div className="relative">
              <Controller
                control={control}
                render={({ field: { value } }) => (
                  <input
                    type="radio"
                    checked={value || false}
                    value="Days to months"
                    onChange={() => handleChange('1')}
                    id="one"
                    className="absolute z-20 w-8 h-8 rounded-full outline-none opacity-0 cursor-pointer peer zone-1"
                  ></input>
                )}
                name="type"
              ></Controller>
              <div
                onClick={() => handleChange('1')}
                ref={jobZone1Ref}
                className="cursor-pointer z-0 absolute bg-white inset-0 rounded-full border-2 border-careerPageHeading h-8 w-8 after:content-[''] sm:after:h-16 after:h-20 after:w-0.5 after:bg-dark-gray/20 after:absolute after:top-[30px] after:left-3.5 relative z-20 after:z-10  "
              ></div>
            </div>
            <label htmlFor="one" className="flex flex-col cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading whitespace-nowrap">
                Days to months
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                Usually, an experienced worker can show you how to do the job.{' '}
              </p>
            </label>
          </div>
          <div className="flex items-center my-4">
            <div className="relative">
              <Controller
                control={control}
                render={({ field: { value } }) => (
                  <input
                    type="radio"
                    checked={value || false}
                    value="Up to 1 year"
                    onChange={() => handleChange('2')}
                    id="two"
                    className="absolute z-20 w-8 h-8 rounded-full outline-none opacity-0 cursor-pointer peer zone-1"
                  ></input>
                )}
                name="type"
              ></Controller>

              <div
                onClick={() => handleChange('2')}
                ref={jobZone2Ref}
                className="cursor-pointer z-0 absolute bg-white inset-0 rounded-full border-2 border-careerPageHeading h-8 w-8 after:content-[''] sm:after:h-16 after:h-20 after:w-0.5 after:bg-dark-gray/20 after:absolute after:top-[30px] after:left-3.5 relative z-20 after:z-10  "
              ></div>
            </div>
            <label htmlFor="two" className="flex flex-col cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading whitespace-nowrap">
                Up to 1 year{' '}
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                Working with experienced employees to learn, such as an
                apprenticeship program.{' '}
              </p>
            </label>
          </div>
          <div className="flex items-center my-4">
            <div className="relative">
              <Controller
                control={control}
                render={({ field: { value } }) => (
                  <input
                    type="radio"
                    checked={value || false}
                    value="1-2 year"
                    onChange={() => handleChange('3')}
                    id="three"
                    className="absolute z-20 w-8 h-8 rounded-full outline-none opacity-0 cursor-pointer peer zone-1"
                  ></input>
                )}
                name="type"
              ></Controller>
              <div
                ref={jobZone3Ref}
                onClick={() => handleChange('3')}
                className="cursor-pointer z-0 absolute bg-white inset-0 rounded-full border-2 border-careerPageHeading h-8 w-8 after:content-[''] sm:after:h-16 after:h-20 after:w-0.5 after:bg-dark-gray/20 after:absolute after:top-[30px] after:left-3.5 relative z-20 after:z-10  "
              ></div>
            </div>
            <label htmlFor="three" className="flex flex-col cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading whitespace-nowrap">
                Up to 1-2 years
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                Both on-the-job experience and informal training with
                experienced workers may be needed.{' '}
              </p>
            </label>
          </div>
          <div className="flex items-center my-4">
            <div className="relative">
              <Controller
                control={control}
                render={({ field: { value } }) => (
                  <input
                    type="radio"
                    checked={value || false}
                    value="4 years"
                    onChange={() => handleChange('4')}
                    id="four"
                    className="absolute z-20 w-8 h-8 rounded-full outline-none opacity-0 cursor-pointer peer zone-1"
                  ></input>
                )}
                name="type"
              ></Controller>
              <div
                ref={jobZone4Ref}
                onClick={() => handleChange('4')}
                className="cursor-pointer z-0 absolute bg-white inset-0 rounded-full border-2 border-careerPageHeading h-8 w-8 after:content-[''] sm:after:h-16 after:h-20 after:w-0.5 after:bg-dark-gray/20 after:absolute after:top-[30px] after:left-3.5 relative z-20 after:z-10  "
              ></div>
            </div>
            <label htmlFor="four" className="flex flex-col cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading whitespace-nowrap">
                4 years
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                Most require a four-year bachelor's degree and on-the-job
                experience.{' '}
              </p>
            </label>
          </div>
          <div className="flex items-center my-4">
            <div className="relative">
              <Controller
                control={control}
                render={({ field: { value } }) => (
                  <input
                    type="radio"
                    checked={value || false}
                    value="More than 4 years"
                    onChange={() => handleChange('5')}
                    id="five"
                    className="absolute z-20 w-8 h-8 rounded-full outline-none opacity-0 cursor-pointer peer zone-1"
                  ></input>
                )}
                name="type"
              ></Controller>
              <div
                ref={jobZone5Ref}
                onClick={() => handleChange('5')}
                className="absolute relative inset-0 z-0 z-20 w-8 h-8 bg-white border-2 rounded-full cursor-pointer border-careerPageHeading "
              ></div>
            </div>
            <label htmlFor="five" className="flex flex-col cursor-pointer">
              <p className="ml-4 text-2xl font-bold text-careerPageHeading whitespace-nowrap">
                More than 4 years
              </p>
              <p className="mb-1 ml-4 text-sm text-careerPageHeading">
                A graduate degree and some on-the-job training{' '}
              </p>
            </label>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepTwo;
